import React from "react";
import AccountSidebar, { AccountRole } from "./AccountSidebar";
import Header from "./Header";
import avatar from "../../assets/avatar.png";
import { useAuth } from "../../context/AuthContext";

export default function AccountShell({ role, activeItem, title, children }: {
  role: AccountRole; activeItem: string; title: string; children: React.ReactNode;
}) {
  const { user } = useAuth();
  return <div className="account-profile-page">
    <Header />
    <div className="account-profile-layout">
      <div className="account-navigation"><AccountSidebar role={role} activeItem={activeItem} avatar={avatar} name={user?.nome_completo} /></div>
      <main className="account-profile-content">
        <div className="account-page-heading"><h1>{title}</h1></div>
        {children}
      </main>
    </div>
  </div>;
}
